export enum AlignTypesHorizontal {
  Start = 'start',
  End = 'end',
  Center = 'center',
}
